import * as React from 'react';
import { CurrencyType } from '../../models/utilities/type-models';
import { Currency } from '../currency/Currency';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id              : string;
    label           : string;
    value           : any;
    onChange        : any;
    currencyType    : CurrencyType;
    showSymbol      : boolean;
    className?      : string;
    error?          : string;
    disable?        : boolean;
    isOptional?     : boolean;
}

// #endregion

export class CurrencyInput extends React.Component<IProps> {

    public static defaultProps = {
        className   : '',
        error       : '',
        disable     : false,
        isOptional  : false
    };

    private child = {} as any;

    public render() {
        const { className, id, error, label, value, onChange, disable, currencyType, showSymbol } = this.props;
        return (
            <div className={'form-group ' + (className)}>
                <InputLabel htmlFor={id} error={error}>
                    {label}
                </InputLabel>
                <Currency 
                    id={ id } 
                    ref={(instance) => { this.child = instance; }}
                    currencyType={ currencyType }
                    showSymbol={ showSymbol }
                    value={ value } 
                    onChange={ onChange } 
                    disable={ disable } />
                <InputFeedback error={error} />
            </div>
        );
    }

    public reset() {
        this.child.reset();
    }
}
